// src/store/mappers/normalizers.ts
import type { UserRow } from '@/types/users.types';
import { type OrgUserStatus, normalizeOrgUsersStatus as normalizeFromTypes } from '@/types/status.types';

/** Generic normalizer factory kept for other enums if you want — otherwise use specific functions */
function createStringEnumNormalizer<T extends string>(
  strategies: Record<string, T>,
  fallback: T
) {
  return (input: unknown): T => {
    const key = typeof input === 'string' ? input.toLowerCase() : '';
    return strategies[key] ?? fallback;
  };
}

/* ------------------------- User Status (OrgUserStatus) ------------------------- */

// re-export or wrap the central normalizer so other modules can still import from this file
export const normalizeOrgUserStatus = (input: unknown): OrgUserStatus =>
  normalizeFromTypes(input);

/* ------------------------- User Type (UserRow['userType']) ------------------------- */

type UserType = UserRow['userType']; // 'Internal' | 'External'

const userTypeStrategy: Record<string, UserType> = {
  internal: 'Internal',
  external: 'External',
};

export const normalizeUserType = createStringEnumNormalizer<UserType>(
  userTypeStrategy,
  'Internal' // fallback
);
